var _rect, _path, _circle, _path2, _g, _rect2, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_38)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_38)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_0_38)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4933 25.6282C31.5556 25.2255 31.1727 24.9076 30.8146 25.0648L23.6824 28.1962C23.4256 28.309 23.4444 28.6979 23.7107 28.7827L25.1816 29.2511C25.4623 29.3405 25.7663 29.2943 26.0114 29.125L29.3275 26.8339C29.4275 26.7649 29.5365 26.907 29.451 26.9951L27.0641 29.4561C26.8325 29.6949 26.8785 30.0994 27.157 30.274L29.8295 31.9499C30.1292 32.1379 30.5148 31.9491 30.5709 31.5869L31.4933 25.6282Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.5238,
    r: 7,
    fill: "url(#paint0_linear_0_38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4933 25.6282C31.5556 25.2255 31.1727 24.9076 30.8146 25.0648L23.6824 28.1962C23.4256 28.309 23.4444 28.6979 23.7107 28.7827L25.1816 29.2511C25.4623 29.3405 25.7663 29.2943 26.0114 29.125L29.3275 26.8339C29.4275 26.7649 29.5365 26.907 29.451 26.9951L27.0641 29.4561C26.8325 29.6949 26.8785 30.0994 27.157 30.274L29.8295 31.9499C30.1292 32.1379 30.5148 31.9491 30.5709 31.5869L31.4933 25.6282Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_38)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 42.0238,
    rx: 11.5,
    ry: 6.5,
    fill: "#1893D1"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 12.6238,
    width: 31.8,
    height: 31.8,
    rx: 15.9,
    stroke: "url(#paint1_radial_0_38)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter3_f_0_38)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29.5238,
    r: 9,
    fill: "white",
    fillOpacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_38",
    x: 2,
    y: 2.5238,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_38",
    x: 8,
    y: 8.5238,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_0_38"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_38",
    x: 1,
    y: 17.5238,
    width: 59,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_38"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_38",
    x: 0,
    y: 0.523804,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_0_38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_38",
    x1: 28,
    y1: 21.5238,
    x2: 28,
    y2: 35.5238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2878 13.4759) rotate(44.0741) scale(43.4569 69.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.7d87b5cc27cb96cfc8fae57e625edae3.svg";
export { ForwardRef as ReactComponent };